import { envConfig } from './environment-common';

export const environment = {
  ...envConfig,
  production: false,
  apiUrl: 'https://dev-2.crm.justfood.pro/api/apps/mobile',
  apiCrm: 'https://dev-2.crm.justfood.pro/api',
  cloudPaymentsPublicId: 'pk_3828723d39b545ffba4dea569c3e7'
};
